import { useQuery } from "@apollo/client"
import { IGetHealthCoachB2BCompanyInput, IGetHealthCoachB2BCompanyOutput, IPatient } from "../../../graphql/types/queries/patient"
import { GET_B2B_COMPANY } from "../../../graphql/queries"
import SpinLoader from "../../../components/SpinLoader"
import moment from "moment"
import { Flex, Heading, Button, Text } from "rebass/styled-components"

interface IProps {
  patient: IPatient
}
const False = () => {
  return (<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.11997 5.99997L11.65 9.52997L9.52997 11.65L5.99997 8.11997L2.45997 11.66L0.339966 9.53997L3.87997 5.99997L0.339966 2.45997L2.45997 0.339966L5.99997 3.87997L9.53997 0.349966L11.66 2.46997L8.11997 5.99997Z" fill="#F24E1E" />
  </svg>)
}
const True = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.54998 18L3.84998 12.3L5.27498 10.875L9.54998 15.15L18.725 5.97498L20.15 7.39998L9.54998 18Z" fill="#4ECB71" />
  </svg>
  )
}

const TrueFalse = ({ value }: { value: boolean }) => {
  if (!!value) return <True />

  return <False />
}

const Freeness = ({ text, value }: { text: string, value?: boolean }) => {
  return (
    <Flex mb={2} alignItems={'center'}>
      <Text mr={2}>
        {text}
      </Text>
      <TrueFalse value={!!value} />
    </Flex>
  )
}

const Restriction = ({ text, value }: { text: string, value?: boolean }) => {
  return (
    <Flex mb={2} alignItems={'center'}>
      <Text mr={2}>
        {text}
      </Text>
      <TrueFalse value={!value} />
    </Flex>
  )
}

const FreenessString = ({ text, value, showIfEmpty = false }: { text: string, value?: string, showIfEmpty?: boolean }) => {
  if (!showIfEmpty && !value) return null

  return (
    <Flex mb={2} alignItems={'center'}>
      <Text mr={2}>
        {text}
      </Text>
      <Text mr={2} style={{ fontWeight: 600 }}>
        {value}
      </Text>
    </Flex>
  )
}

export const B2BFreenessModal: React.FC<IProps> = ({ patient }) => {
  const { data, loading } = useQuery<IGetHealthCoachB2BCompanyOutput, IGetHealthCoachB2BCompanyInput>(GET_B2B_COMPANY, {
    variables: {
      companyId: patient.b2b!.companyId!
    }
  })

  if (!!loading) {
    return <SpinLoader />
  }

  const normalizeDuration = (duration?: string) => {
    if (!duration) return undefined
    return duration.replace('-m', ' month(s)').replace('-d', ' day(s)').replace('-y', ' year(s)')
  }
  const freeness = data?.getHealthCoachB2BCompany.freeness || data?.getHealthCoachB2BCompany.broker?.defaultFreeness

  return (
    <Flex flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
      <Heading mt={4} mb={3}>B2B Freeness</Heading>
      <Freeness text='Kit:' value={freeness?.kit} />
      <Freeness text='Membership:' value={freeness?.membership} />
      <Freeness text='Visits:' value={freeness?.visits} />
      <Freeness text='Nutritionist:' value={freeness?.nutritionist} />
      <Freeness text='Vitamins:' value={freeness?.vitamins} />
      <FreenessString text='Expires After:' value={normalizeDuration(freeness?.expiresAfter)} />
    </Flex>
  )
}

export const B2BRestrictionsModal: React.FC<IProps> = ({ patient }) => {
  const { data, loading } = useQuery<IGetHealthCoachB2BCompanyOutput, IGetHealthCoachB2BCompanyInput>(GET_B2B_COMPANY, {
    variables: {
      companyId: patient.b2b!.companyId!
    }
  })

  if (!!loading) {
    return <SpinLoader />
  }

  const restrictions = data?.getHealthCoachB2BCompany.restrictions || data?.getHealthCoachB2BCompany.broker?.defaultRestrictions

  return (
    <Flex flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
      <Heading mt={4} mb={3}>B2B Restrictions</Heading>
      <Restriction text='hypo:' value={restrictions?.hypo} />
      <Restriction text='menopause:' value={restrictions?.meno} />
      <Restriction text='weightloss:' value={restrictions?.weightloss} />
    </Flex>
  )
}